import cx from 'classnames';
import PropTypes from 'prop-types';

import * as style from './grid.module.scss';

const Grid = ({ children, className }) => {
  return <div className={cx(className, style.grid)}>{children}</div>;
};

Grid.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Grid;
